// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 31952, offsets 155184:189241. Structure and names inferred from code, not screenshots.

import { module16103 as o } from "../vendor/dependencies.js";
import a from "../content/extracted/31952-a.json";
(0, o.CQ)(a);
let Icon = ({
  icon: icon,
  prefix: t = "mimo",
  size: size,
  style: a = {},
  ...r
}) => (
  <o.In
    icon={`${t}:${icon}`}
    style={{
      fontSize: `${size}px`,
      ...a,
    }}
    fallback={
      <div
        style={{
          width: `${size || 0}px`,
          height: `${size || 0}px`,
        }}
      />
    }
    {...r}
  />
);
export { Icon };
